export const serviceRequestConstants = {
  SERVICE_REQUEST_TEMPLATE_CATEGORIES_LIST_REQUEST:
    "SERVICE_REQUEST_TEMPLATE_CATEGORIES_LIST_REQUEST",
  SERVICE_REQUEST_TEMPLATE_CATEGORIES_LIST_COMPLETE:
    "SERVICE_REQUEST_TEMPLATE_CATEGORIES_LIST_COMPLETE",
  SERVICE_REQUEST_TEMPLATE_CATEGORIES_LIST_ERROR:
    "SERVICE_REQUEST_TEMPLATE_CATEGORIES_LIST_ERROR",
  CLEAR_SERVICE_REQUEST: "CLEAR_SERVICE_REQUEST",

  CLEAR_SERVICE_REQUEST_CATEGORY: "CLEAR_SERVICE_REQUEST_CATEGORY",

  SET_SERVICE_REQUEST_CATEGORY: "SET_SERVICE_REQUEST_CATEGORY",

  SET_SERVICE_REQUEST_TEMPLATE: "SET_SERVICE_REQUEST_TEMPLATE",

  CLEAR_SERVICE_REQUEST_TEMPLATE_FIELDS:
    "CLEAR_SERVICE_REQUEST_TEMPLATE_FIELDS",

  SERVICE_REQUEST_TEMPLATE_LIST_REQUEST:
    "SERVICE_REQUEST_TEMPLATE_LIST_REQUEST",
  SERVICE_REQUEST_TEMPLATE_LIST_COMPLETE:
    "SERVICE_REQUEST_TEMPLATE_LIST_COMPLETE",
  SERVICE_REQUEST_TEMPLATE_LIST_ERROR: "SERVICE_REQUEST_TEMPLATE_LIST_ERROR",

  SET_SERVICE_REQUEST_INITIATE_DATA: "SET_SERVICE_REQUEST_INITIATE_DATA",

  CLEAR_SERVICE_REQUEST_INITIATE_DATA: "CLEAR_SERVICE_REQUEST_INITIATE_DATA",

  SET_SERVICE_REQUEST_FROM_EXTERNAL: "SET_SERVICE_REQUEST_FROM_EXTERNAL",
  CLEAR_SERVICE_REQUEST_FROM_EXTERNAL: "CLEAR_SERVICE_REQUEST_FROM_EXTERNAL",

  SERVICE_REQUEST_TEMPLATE_FIELDS_REQUEST:
    "SERVICE_REQUEST_TEMPLATE_FIELDS_REQUEST",
  SERVICE_REQUEST_TEMPLATE_FIELDS_COMPLETE:
    "SERVICE_REQUEST_TEMPLATE_FIELDS_COMPLETE",
  SERVICE_REQUEST_TEMPLATE_FIELDS_ERROR:
    "SERVICE_REQUEST_TEMPLATE_FIELDS_ERROR",

  SERVICE_REQUEST_ASSETS_OPTIONS_REQUEST:
    "SERVICE_REQUEST_ASSETS_OPTIONS_REQUEST",
  SERVICE_REQUEST_ASSETS_OPTIONS_COMPLETE:
    "SERVICE_REQUEST_ASSETS_OPTIONS_COMPLETE",
  SERVICE_REQUEST_ASSETS_OPTIONS_ERROR: "SERVICE_REQUEST_ASSETS_OPTIONS_ERROR",

  CLEAR_SERVICE_REQUEST_ASSET_OPTION: "CLEAR_SERVICE_REQUEST_ASSET_OPTION",

  SET_IS_PAGINATING_ASSET_OPTIONS: "SET_IS_PAGINATING_ASSET_OPTIONS",

  SERVICE_REQUEST_VALIDATE_REQUEST: "SERVICE_REQUEST_VALIDATE_REQUEST",
  SERVICE_REQUEST_VALIDATE_COMPLETE: "SERVICE_REQUEST_VALIDATE_COMPLETE",
  SERVICE_REQUEST_VALIDATE_ERROR: "SERVICE_REQUEST_VALIDATE_ERROR",

  SERVICE_REQUEST_INITIATE_REQUEST: "SERVICE_REQUEST_INITIATE_REQUEST",
  SERVICE_REQUEST_INITIATE_COMPLETE: "SERVICE_REQUEST_INITIATE_COMPLETE",
  SERVICE_REQUEST_INITIATE_ERROR: "SERVICE_REQUEST_INITIATE_ERROR",

  SERVICE_REQUEST_OTP_REQUEST: "SERVICE_REQUEST_OTP_REQUEST",
  SERVICE_REQUEST_OTP_COMPLETE: "SERVICE_REQUEST_OTP_COMPLETE",
  SERVICE_REQUEST_OTP_ERROR: "SERVICE_REQUEST_OTP_ERROR",

  SERVICE_REQUEST_RESEND_OTP_REQUEST: "SERVICE_REQUEST_RESEND_OTP_REQUEST",
  SERVICE_REQUEST_RESEND_OTP_COMPLETE: "SERVICE_REQUEST_RESEND_OTP_COMPLETE",
  SERVICE_REQUEST_RESEND_OTP_ERROR: "SERVICE_REQUEST_RESEND_OTP_ERROR",

  SERVICE_REQUEST_FILE_UPLOAD_REQUEST: "SERVICE_REQUEST_FILE_UPLOAD_REQUEST",
  SERVICE_REQUEST_FILE_UPLOAD_COMPLETE: "SERVICE_REQUEST_FILE_UPLOAD_COMPLETE",
  SERVICE_REQUEST_FILE_UPLOAD_ERROR: "SERVICE_REQUEST_FILE_UPLOAD_ERROR",

  SERVICE_REQUEST_FILE_DELETE_REQUEST: "SERVICE_REQUEST_FILE_DELETE_REQUEST",
  SERVICE_REQUEST_FILE_DELETE_COMPLETE: "SERVICE_REQUEST_FILE_DELETE_COMPLETE",
  SERVICE_REQUEST_FILE_DELETE_ERROR: "SERVICE_REQUEST_FILE_DELETE_ERROR",

  SERVICE_REQUEST_FILE_GET_REQUEST: "SERVICE_REQUEST_FILE_GET_REQUEST",
  SERVICE_REQUEST_FILE_GET_COMPLETE: "SERVICE_REQUEST_FILE_GET_COMPLETE",
  SERVICE_REQUEST_FILE_GET_ERROR: "SERVICE_REQUEST_FILE_GET_ERROR",

  TEXT_INPUT_FIELD_TYPE: "TEXT_INPUT",
  DROPDOWN_FIELD_TYPE: "DROPDOWN",
  DATE_FIELD_TYPE: "DATE",
  DATE_RANGE_FIELD_TYPE: "DATE_RANGE",
  VALUE_RANGE_FIELD_TYPE: "VALUE_RANGE",
  AMOUNT_FIELD_TYPE: "AMOUNT",
  NUMBER_FIELD_TYPE: "NUMBER",
  ASSET_TYPE_FIELD_TYPE: "ASSET",

  NUMBER_TYPE_PERCENTAGE: "PERCENTAGE",

  ASSET_TEMPLATE_1_TYPE: "TEMPLATE_1",
  ASSET_TEMPLATE_2_TYPE: "TEMPLATE_2",
  ASSET_TEMPLATE_3_TYPE: "TEMPLATE_3",

  SERVICE_REQUEST_SUBMISSION_FAILED_STATUS: "SUBMISSION_FAILED",
  SERVICE_REQUEST_FAILED_STATUS: "FAILED",
  SERVICE_REQUEST_SUBMISSION_SUCCESS_STATUS: "SUBMITTED",
  SERVICE_REQUEST_SUBMISSION_SUCCESSFULLY_SUBMITTED_STATUS:
    "SUCCESSFULLY_SUBMITTED",

  SERVICE_REQUEST_LIST_REQUEST: "SERVICE_REQUEST_LIST_REQUEST",
  SERVICE_REQUEST_LIST_COMPLETE: "SERVICE_REQUEST_LIST_COMPLETE",
  SERVICE_REQUEST_LIST_ERROR: "SERVICE_REQUEST_LIST_ERROR",

  SERVICE_REQUEST_FILTER_DATA_REQUEST: "SERVICE_REQUEST_FILTER_DATA_REQUEST",
  SERVICE_REQUEST_FILTER_DATA_COMPLETE: "SERVICE_REQUEST_FILTER_DATA_COMPLETE",
  SERVICE_REQUEST_FILTER_DATA_ERROR: "SERVICE_REQUEST_FILTER_DATA_ERROR",

  SERVICE_REQUEST_DETAILS_REQUEST: "SERVICE_REQUEST_DETAILS_REQUEST",
  SERVICE_REQUEST_DETAILS_COMPLETE: "SERVICE_REQUEST_DETAILS_COMPLETE",
  SERVICE_REQUEST_DETAILS_ERROR: "SERVICE_REQUEST_DETAILS_ERROR",

  CLEAR_SERVICE_REQUEST_DETAILS: "CLEAR_SERVICE_REQUEST_DETAILS",

  SET_IS_PAGINATING_SERVICE_REQUEST_LIST:
    "SET_IS_PAGINATING_SERVICE_REQUEST_LIST",

  CLEAR_SERVICE_REQUEST_RESPONSES: "CLEAR_SERVICE_REQUEST_RESPONSES",

  SERVICE_REQUEST_CANCEL_REQUEST: "SERVICE_REQUEST_CANCEL_REQUEST",
  SERVICE_REQUEST_CANCEL_COMPLETE: "SERVICE_REQUEST_CANCEL_COMPLETE",
  SERVICE_REQUEST_CANCEL_ERROR: "SERVICE_REQUEST_CANCEL_ERROR",

  CUSTOMER_ADDRESS_ASSET: "CUSTOMER_ADDRESS",

  FILTER_ACCEPTED_STATUS: "ACCEPTED",
  FILTER_CANCELED_STATUS: "CANCELED",
  FILTER_COMPLETED_STATUS: "COMPLETED",
  FILTER_DECLINED_STATUS: "DECLINED",
  FILTER_DISPATCHED_STATUS: "DISPATCHED",
  FILTER_FAILED_STATUS: "FAILED",
  FILTER_INITIATED_STATUS: "INITIATED",
  FILTER_SUBMISSION_FAILED_STATUS: "SUBMISSION_FAILED",
  FILTER_SUBMITTED_STATUS: "SUBMITTED",
  FILTER_SUCCESSFULLY_SUBMITTED_STATUS: "SUCCESSFULLY_SUBMITTED",
  FILTER_SUCCESSFUL_STATUS: "SUCCESSFUL",

  FORMULA_FIELD_TYPE: "FORMULA",
  FILE_UPLOAD_FIELD_TYPE: "FILE_UPLOAD",

  SINGLE_DISPLAY_TYPE: "SINGLE",
  SERVICE_REQUEST_ASSET_DISPLAY_TYPE_LIST: "LIST",
  SERVICE_REQUEST_ASSET_DISPLAY_TYPE_SINGLE: "SINGLE",
  SERVICE_REQUEST_MULTI_SELECT_ASSET_DISPLAY_LIMIT: 3,

  SERVICE_REQUEST_WIZARD_LIST_STEP: 1,
  SERVICE_REQUEST_WIZARD_CATEGORIES_STEP: 2,
  SERVICE_REQUEST_WIZARD_TEMPLATE_LIST_STEP: 3,
  SERVICE_REQUEST_WIZARD_FORM_STEP: 4,
  SERVICE_REQUEST_WIZARD_TERMS_STEP: 5,
  SERVICE_REQUEST_WIZARD_CONFIRMATION_STEP: 6,
  SERVICE_REQUEST_WIZARD_COMPLETE_STEP: 7,
};

export const serviceRequestFormulaTokenTypes = {
  NUMBER: "number",
  STRING: "string",
  IDENTIFIER: "identifier",
  SYMBOL: "symbol",
};

export const serviceRequestFormulaSafeGlobalNames = [
  "CALC_PCT",
  "RND_STEP",
  "CALC_INT",
  "CALC_FEE",
  "Math",
  "Number",
  "Date",
];

export const SERVICE_REQUEST_FORMULA_FIELD_REFERENCE_REGEX =
  /\b[A-Za-z][A-Za-z0-9_]*\b/g;

export const serviceRequestFormulaReservedNames = [
  ...serviceRequestFormulaSafeGlobalNames,
  serviceRequestConstants.TEXT_INPUT_FIELD_TYPE,
  serviceRequestConstants.DROPDOWN_FIELD_TYPE,
  serviceRequestConstants.DATE_FIELD_TYPE,
  serviceRequestConstants.DATE_RANGE_FIELD_TYPE,
  serviceRequestConstants.VALUE_RANGE_FIELD_TYPE,
  serviceRequestConstants.AMOUNT_FIELD_TYPE,
  serviceRequestConstants.NUMBER_FIELD_TYPE,
  serviceRequestConstants.ASSET_TYPE_FIELD_TYPE,
  serviceRequestConstants.FORMULA_FIELD_TYPE,
  serviceRequestConstants.FILE_UPLOAD_FIELD_TYPE,
  serviceRequestConstants.ASSET_TEMPLATE_1_TYPE,
  serviceRequestConstants.ASSET_TEMPLATE_2_TYPE,
  serviceRequestConstants.ASSET_TEMPLATE_3_TYPE,
  serviceRequestConstants.CUSTOMER_ADDRESS_ASSET,
];

export const serviceRequestCodes = {
  SERVICE_REQUEST_DISPUTE_RAISED: "SR000",
  SERVICE_REQUEST_CASH_BACK_LOAN: "SR001",
  SERVICE_REQUEST_BLOCK_CREDIT_CARD: "SR002",
  SERVICE_REQUEST_UNBLOCK_CREDIT_CARD: "SR003",
};

export const serviceRequestCategoryCodes = {
  CURRENT_ACCOUNT_SERVICES_REQUEST_CATEGORY_CODE: "SRC01",
  CREDIT_CARD_SERVICES_REQUEST_CATEGORY_CODE: "SRC02",

  CREDIT_CARD_BLOCK_ASSET_FIELD_CODE: "FIELD_1",
};
